/**
 * This returns cookie value corresponding to passed cookieName
 * @param cookieName
 * @returns cookieValue: string
 */
export default cookieName => {
  const cookies = document.cookie
    .split(';')
    .map(x => x.split('='))
    .find(([name]) => name.trim() === cookieName)
  if (cookies) return cookies[1].trim()
}
